<!-- Component that implements the navbar layout -->
<template lang="html">
  <v-app fill-height>
    <app-menu v-if="!$route.meta.plainLayout"></app-menu>
    <app-content></app-content>
    <app-footer v-if="!$route.meta.plainLayout"></app-footer>
    <app-snackbar></app-snackbar>
  </v-app>
</template>

<script>
  import AppMenu from '@/components/app-layouts/menu.vue'
  import AppContent from '@/components/app-layouts/content.vue'
  import AppFooter from '@/components/app-layouts/footer.vue'
  import AppSnackbar from '@/components/app-layouts/app-snackbar/snackbar'

  export default {
    name: 'app',
    components: {
      'app-menu': AppMenu,
      'app-content': AppContent,
      'app-footer': AppFooter,
      'app-snackbar': AppSnackbar
    }
  }
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// app-responsive-layout.vue?fb31eed2